import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'app-board-filter-button',
    templateUrl: './board-filter-button.component.html',
    styleUrls: ['./board-filter-button.component.scss']
})
export class BoardFilterButtonComponent implements OnInit {

    managersFilter: boolean;
    customersFilter: boolean;
    statusesFilter: boolean;

    constructor(
    ) {

    }

    ngOnInit(): void {
    }

    updateManagers(event: boolean) {
        this.managersFilter = event;
    }

    updateCustomers(event: boolean) {
        this.customersFilter = event;
    }

    updateStatuses(event: boolean) {
        this.statusesFilter = event;
    }


}
